module.exports = __webpack_public_path__ + "static/media/Q4_Front_Left.a55459f5.png";